import type { AiObservabilityAccessState } from '../features/aiObservability/aiObservabilityAccess';
import { AI_OBSERVABILITY_ACCESS, WORKER_CHAT_ACCESS } from '../features/aiObservability/aiObservabilityAccess';
import type { ChatDashboardAccessState } from '../features/chat/chatDashboardAccess';
import { CHAT_DASHBOARD_ACCESS } from '../features/chat/chatDashboardAccess';
import type { FeatureFlags } from '../types/featureFlags';
import type { SubAppConfig } from '../types/app.types';

export const isSubAppVisible = (
    app: SubAppConfig,
    flags: FeatureFlags,
    aiObservabilityAccess: AiObservabilityAccessState,
    workerChatAccess: AiObservabilityAccessState = 'denied',
    chatDashboardAccess: ChatDashboardAccessState = 'denied',
): boolean => {
    if (app.featureFlag && !flags[app.featureFlag]) return false;
    if (app.requiredAccess === AI_OBSERVABILITY_ACCESS) {
        return aiObservabilityAccess === 'allowed';
    }
    if (app.requiredAccess === WORKER_CHAT_ACCESS) return workerChatAccess === 'allowed';
    if (app.requiredAccess === CHAT_DASHBOARD_ACCESS) return chatDashboardAccess === 'allowed';
    return true;
};
